import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px 0;
  min-height: 280px;
  img {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
`;

export const Error = styled.div`
  color: #f00;
`;

export const Info = styled.div`
  margin: 10px 0 0;
  overflow-wrap: break-word;
  padding: 5px;
  border: 2px solid var(--cp-border, #ccc);
  border-radius: 4px;
  cursor: copy;
  transition: 0.2s all ease-in;
  &:hover {
    border-color: var(--cp-border, #000);
  }
`;
